import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as H } from "./index.es2359.js";
function e({ size: V = H }) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: V,
      height: V,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.468262", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M16.1139 20.4683C16.051 20.4683 16 20.5192 16 20.5821V23.4683H14V25.4683C14 26.5728 14.8954 27.4683 16 27.4683H16.0247C16.225 29.4856 17.6243 31.1503 19.5 31.7394V32.4683C19.5 33.2967 20.1716 33.9683 21 33.9683C21.8284 33.9683 22.5 33.2967 22.5 32.4683V31.7394C24.3757 31.1503 25.775 29.4856 25.9753 27.4683H26C27.1046 27.4683 28 26.5728 28 25.4683V23.4683H26V20.5821C26 20.5192 25.949 20.4683 25.8861 20.4683H16.1139Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M14 19.9683C14 18.0353 15.567 16.4683 17.5 16.4683H28V23.4683H26V20.5821C26 20.5192 25.949 20.4683 25.8861 20.4683H16.1139C16.051 20.4683 16 20.5192 16 20.5821V23.4683H14V19.9683Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M19.5 32.4683H17C15.3431 32.4683 14 33.8114 14 35.4683V40.4683H28V35.4683C28 33.8114 26.6569 32.4683 25 32.4683H22.5C22.5 33.2967 21.8284 33.9683 21 33.9683C20.1716 33.9683 19.5 33.2967 19.5 32.4683Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M43 29.9683C43 34.1104 39.6421 37.4683 35.5 37.4683C31.3579 37.4683 28 34.1104 28 29.9683C28 25.8261 31.3579 22.4683 35.5 22.4683C39.6421 22.4683 43 25.8261 43 29.9683Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M19.0664 27.1032C19.3233 27.0018 19.6137 27.1278 19.7151 27.3847C19.9084 27.8745 20.4038 28.2349 20.9995 28.2349C21.595 28.2349 22.0908 27.8745 22.2852 27.384C22.3869 27.1273 22.6775 27.0017 22.9342 27.1034C23.1909 27.2052 23.3166 27.4957 23.2148 27.7525C22.8696 28.6236 22.0057 29.2349 20.9995 29.2349C19.9934 29.2349 19.1291 28.6237 18.7849 27.7518C18.6835 27.495 18.8096 27.2046 19.0664 27.1032Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M26 27.4683C27.1046 27.4683 28 26.5728 28 25.4683V16.4683H17.5C15.567 16.4683 14 18.0353 14 19.9683V25.4683C14 26.5728 14.8954 27.4683 16 27.4683H16.0247C16.2067 29.3019 17.3794 30.8442 19 31.5522V32.4683H17C15.3431 32.4683 14 33.8114 14 35.4683V40.4683H28V35.4683C28 33.8114 26.6569 32.4683 25 32.4683H23V31.5522C24.6206 30.8442 25.7933 29.3019 25.9753 27.4683H26ZM27 17.4683H17.5C16.1193 17.4683 15 18.5875 15 19.9683V23.4683H16V20.5821C16 20.5192 16.051 20.4683 16.1139 20.4683H25.8861C25.949 20.4683 26 20.5192 26 20.5821V23.4683H27V17.4683ZM21 30.9683C23.2091 30.9683 25 29.1774 25 26.9683V21.4683H17V26.9683C17 29.1774 18.7909 30.9683 21 30.9683ZM26 26.4683C26.5523 26.4683 27 26.0205 27 25.4683V24.4683H26V26.4683ZM16 24.4683H15V25.4683C15 26.0205 15.4477 26.4683 16 26.4683V24.4683ZM19.2676 33.4683H17C15.8954 33.4683 15 34.3637 15 35.4683V39.4683H27V35.4683C27 34.3637 26.1046 33.4683 25 33.4683H22.7324C22.3866 34.0661 21.7403 34.4683 21 34.4683C20.2597 34.4683 19.6134 34.0661 19.2676 33.4683ZM21 31.9683C20.6575 31.9683 20.3231 31.9338 20 31.8682V32.4683C20 33.0205 20.4477 33.4683 21 33.4683C21.5523 33.4683 22 33.0205 22 32.4683V31.8682C21.6769 31.9338 21.3425 31.9683 21 31.9683Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M35.1213 25.3684H35.9736V26.6702C36.2476 26.7221 36.5216 26.8085 36.7954 26.9288C37.0966 27.0612 37.3616 27.2165 37.5896 27.395L37.6699 27.4579L37.1092 28.1462L37.0317 28.083L36.9716 28.163C36.7376 27.9872 36.4768 27.8497 36.1885 27.7506C35.8984 27.6509 35.6377 27.6025 35.4056 27.6025C35.0734 27.6025 34.8183 27.6768 34.6308 27.8156C34.4493 27.9499 34.357 28.1385 34.357 28.3948C34.357 28.499 34.3784 28.5914 34.4197 28.6739C34.464 28.7624 34.5175 28.8362 34.5795 28.8964C34.6404 28.9554 34.7339 29.0189 34.8647 29.0853C34.9981 29.1529 35.1197 29.2083 35.2296 29.2517C35.3406 29.2955 35.4914 29.3492 35.6828 29.4129C35.8971 29.4833 36.063 29.5386 36.1802 29.5788C36.2995 29.6197 36.4466 29.6765 36.621 29.7489C36.7969 29.822 36.9373 29.8919 37.0395 29.9593C37.139 30.0249 37.246 30.1088 37.3603 30.2102C37.4794 30.3157 37.5721 30.429 37.6356 30.5506C37.6964 30.6673 37.7469 30.8033 37.7877 30.9575C37.8296 31.1156 37.8502 31.2867 37.8502 31.47C37.8502 31.9997 37.6748 32.4406 37.3212 32.7843C36.9861 33.1098 36.5339 33.2993 35.9736 33.36V34.5684H35.1213V33.348C34.393 33.2499 33.7453 32.9213 33.1801 32.3665L33.1147 32.3024L33.674 31.6224L33.7512 31.6859L33.822 31.6153C34.078 31.872 34.3643 32.0668 34.6811 32.2007C34.9995 32.3352 35.3117 32.4015 35.6183 32.4015C35.9713 32.4015 36.2477 32.3182 36.456 32.1603C36.6596 32.006 36.7615 31.7972 36.7615 31.5228C36.7615 31.3968 36.7399 31.2866 36.6987 31.1904C36.6554 31.0894 36.6016 31.0061 36.5383 30.939C36.4759 30.8729 36.3829 30.8054 36.2549 30.7382C36.1242 30.6695 35.9972 30.6121 35.8738 30.5657C35.7489 30.5188 35.5833 30.4635 35.3762 30.3998L35.375 30.3994C35.1855 30.3385 35.0344 30.2877 34.9225 30.2471C34.8099 30.2063 34.6719 30.1512 34.5087 30.0821C34.3437 30.0122 34.2096 29.9449 34.1084 29.8798C34.0093 29.8161 33.9026 29.7358 33.7884 29.6395C33.6695 29.5392 33.5754 29.4314 33.5086 29.3155C33.444 29.2035 33.3908 29.0744 33.348 28.9292C33.304 28.7799 33.2825 28.6191 33.2825 28.4476C33.2825 27.9337 33.454 27.5021 33.799 27.1604C34.1267 26.8359 34.5708 26.656 35.1213 26.6124V25.3684Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M35.5 37.4683C39.6421 37.4683 43 34.1104 43 29.9683C43 25.8261 39.6421 22.4683 35.5 22.4683C31.3579 22.4683 28 25.8261 28 29.9683C28 34.1104 31.3579 37.4683 35.5 37.4683ZM35.5 36.4683C39.0899 36.4683 42 33.5581 42 29.9683C42 26.3784 39.0899 23.4683 35.5 23.4683C31.9101 23.4683 29 26.3784 29 29.9683C29 33.5581 31.9101 36.4683 35.5 36.4683Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
e.__tags = [];
export {
  e as MetricIncomePerPersonIcon
};
//# sourceMappingURL=index.es397.js.map
